// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__NNy7M","active":"Navbar_active__3KeoL","navLinkText":"Navbar_navLinkText__gDve_"};